import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap'
import {
  toggleAllAssignableStores,
  toggleAssignableGroupStores,
  setShowSelectedStores,
  setHideSelectedStores,
  filterGroupLocations,
} from 'store/Group/actions'
import Search from '../../../Search'
import SelectedItems from '../../../SelectedItems'

const LocationsModal = (props) => {
  const dispatch = useDispatch()
  const groups = useSelector((state) => state.groups)
  const { items } = props

  const isChecked = (props, property, value) => {
    return props[property].indexOf(value) !== -1
  }
  return (
    <Modal
      className='modal-dialog-centered'
      isOpen={props.isOpen}
      size='xl'
      toggle={() => props.setLocationsModal(!props.isOpen)}
      scrollable
    >
      <ModalHeader
        className='border-bottom pb-2'
        toggle={() => props.setLocationsModal(false)}
      >
        <span className='text-info'>Location</span>
      </ModalHeader>

      <ModalBody className='scrollbar' style={{ minHeight: '60vh' }}>
        <Row className='justify-content-between px-2'>
          <p>All Location Groups:</p>
          <Search
            placeholder={'Search locations'}
            value={groups.filterGroupLocationsValue}
            onChange={(e) => dispatch(filterGroupLocations(e.target.value))}
          />
        </Row>
        <div className='col'>
          <div className='col-3 mb-3 pl-0'>
            <SelectedItems
              items={
                items &&
                items.length > 0 &&
                items
                  .filter((item) =>
                    groups.assignableTrainingStores.includes(item.id)
                  )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
              }
              selectedItems={groups.assignableTrainingStores}
              showSelectedItems={groups.showSelectedStores}
              hasDisabledProperty={false}
              onChange={toggleAssignableGroupStores}
              setShowSelectedItems={() => dispatch(setShowSelectedStores())}
              setHideSelectedItems={() => dispatch(setHideSelectedStores())}
              // language={props.language}
            />
          </div>

          {items && items.length && !groups.filterGroupLocationsValue ? (
            <div className='custom-control custom-checkbox-info mt-4'>
              <input
                className='custom-control-input'
                id='allStores'
                type='checkbox'
                onChange={() => dispatch(toggleAllAssignableStores())}
                checked={
                  items.length === groups.assignableTrainingStores.length
                }
              />
              <label className='custom-control-label' htmlFor='allStores'>
                All
              </label>
            </div>
          ) : null}
          {items &&
            items.length > 0 &&
            items
              .filter(
                (item) =>
                  item.name &&
                  item.name
                    .toLowerCase()
                    .indexOf(groups.filterGroupLocationsValue.toLowerCase()) !==
                    -1
              )
              .map((item, index) => (
                <div
                  key={index}
                  className='custom-control custom-checkbox-info mb-1'
                >
                  <input
                    className='custom-control-input'
                    id={`checkbox${index}`}
                    type='checkbox'
                    onChange={() =>
                      dispatch(toggleAssignableGroupStores(item.id))
                    }
                    checked={isChecked(
                      groups,
                      'assignableTrainingStores',
                      item.id
                    )}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor={`checkbox${index}`}
                  >
                    {item.name && item.name}
                  </label>
                </div>
              ))}
        </div>
      </ModalBody>

      <ModalFooter className='border-top py-2'>
        <Button
          className='ml-auto'
          color='link'
          data-dismiss='modal'
          type='button'
          onClick={() => props.setLocationsModal(false)}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default LocationsModal
